import { graphQLClient, gql } from '@/core/config/graphqlClient'

const GET_POSITIONS_FOR_RECOMMENDATIONS = gql`
  query getRecommendationPositionList($hiringTeamId: ID!, $memberProfileId: ID!) {
    hiringTeam(hiringTeamId: $hiringTeamId) {
      positions(archived: false) {
        nodes {
          id
          name
          recommendationCandidateCards(memberProfileId: $memberProfileId) {
            totalCount
          }
        }
      }
    }
  }
`

export const getPositionsForRecommendations = async ({ hiringTeamId, memberProfileId }) => {
  const data = await graphQLClient(GET_POSITIONS_FOR_RECOMMENDATIONS, {
    hiringTeamId,
    memberProfileId,
  })

  return data
}
